module.exports = __webpack_public_path__ + "static/33-39668ce72c7834dc165954c77e3d2149.png";